import React from "react";
import { cn } from "@/lib/utils";

export default function BrandMark({ className, accentClassName = "text-blue-600", size = "md" }) {
  const sizeClass = size === "lg" ? "text-3xl" : size === "sm" ? "text-xl" : "text-2xl";
  return (
    <span className={cn("inline-flex items-baseline font-display font-black tracking-[-0.06em]", sizeClass, className)}>
      KRAYA<span className={cn("ml-0.5", accentClassName)}>.</span>
    </span>
  );
}
